import type {Category} from "~/types/category";

export const FALLBACK_CATEGORIES: Category[] = [
  {
    "id": 35,
    "code": "CP-15",
    "itemName": "Аксесоари",
    "itemDescription": "Аксесоари",
    "isActive": 1,
    "itemSubName": "Аксесоари",
    "ord": 7,
    "slug": "aksesoari"
  },
  {
    "id": 34,
    "code": "CP-14",
    "itemName": "Филтриращи диспенсъри",
    "itemDescription": "Филтриращи диспенсъри",
    "isActive": 1,
    "itemSubName": "Филтриращи диспенсъри",
    "ord": 6,
    "slug": "filtrirashti-dispensari"
  },
  {
    "id": 33,
    "code": "CP-13",
    "itemName": "Чаши и консумативи",
    "itemDescription": "Чаши и консумативи",
    "isActive": 1,
    "itemSubName": "Чаши и консумативи",
    "ord": 5,
    "slug": "chashi-i-konsumativi"
  },
  {
    "id": 32,
    "code": "CP-12",
    "itemName": "Био & пробиотични продукти",
    "itemDescription": "Био & пробиотични продукти",
    "isActive": 1,
    "itemSubName": "Био & пробиотични продукти",
    "ord": 4,
    "slug": "bio-probiotichni-produkti"
  },
  {
    "id": 30,
    "code": "CP-10",
    "itemName": "Диспенсъри",
    "itemDescription": "",
    "isActive": 1,
    "itemSubName": "Диспенсъри",
    "ord": 3,
    "slug": "dispensari"
  },
  {
    "id": 31,
    "code": "CP-11",
    "itemName": "Кафе",
    "itemDescription": "Кафе",
    "isActive": 1,
    "itemSubName": "Кафе",
    "ord": 2,
    "slug": "kafe"
  },
  {
    "id": 8,
    "code": "CP-09",
    "itemName": "Води",
    "itemDescription": "Води",
    "isActive": 1,
    "itemSubName": "Води",
    "ord": 1,
    "slug": "voda"
  }
];
